import $ from "jquery";
import SimpleLightbox from "simplelightbox";

//console.log("development_gallery running....");

const gallery = new SimpleLightbox('.gallery_grid a');







